/// <reference path="../../modals/modals.ts" />

namespace OfficeGuy.Inputs {
    export class Phone {
        static Init() {
            $(document).on("click.og-phone", 'a[href^="tel:"]:not(.og-phone-disable)', function () {
                var Href = $(this).attr("href");
                var Value = Href.substring(4);
                var Number = Common.FormatWhatsappPhoneNumber(Value);
                if (Number == null || Number == "")
                    return true;

                var $Modal = Modals.ShowHTMLDialog({
                    Simple: true,
                    Title: "קישור לטלפון",
                    HTML: $(document.createElement('div'))
                        .html("מה ברצונך לעשות עם המס' <span class=\"og-inlinertl\">" + Value + "</span>?"),
                    Buttons: [
                        $
                            (document.createElement('input')
                                .attr("type", "button")
                                .addClass("og-button-ui-action", "og-button-color-default")
                                .val("שליחת הודעה ב-Whatsapp"))
                            .click(function () {
                                window.open("https://api.whatsapp.com/send?phone=" + Number);
                                Modals.Hide($Modal);
                                return false;
                            }),
                        $
                            (document.createElement('a')
                                .addClass("og-button-ui-action", "og-button-color-default", "og-phone-disable")
                                .setText("חיוג רגיל"))
                            .click(function () {
                                window.location.href = Href;
                                Modals.Hide($Modal);
                                return true;
                            })
                    ]
                });
                return false;
            });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Inputs.Phone.Init();
});